import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchDocumentTypes, uploadTemplate } from './api';
import { DocumentTypeRead } from './types';
import { ArrowBackOutlined as BackIcon, UploadFileOutlined as UploadIcon } from '@mui/icons-material';

// Импортируем ваш компонент (проверьте корректность пути, если он отличается)
import { JoySelectField } from '../../components/ui/JoySelectField';

const NewTemplate: React.FC = () => {
  const navigate = useNavigate();

  const [types, setTypes] = useState<DocumentTypeRead[]>([]);
  const [loading, setLoading] = useState(false);

  const [file, setFile] = useState<File | null>(null);
  const [name, setName] = useState('');
  const [typeId, setTypeId] = useState<string>('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    fetchDocumentTypes().then(setTypes).catch(console.error);
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!file || !name || !typeId) {
      alert('Пожалуйста, заполните все обязательные поля и выберите файл.');
      return;
    }

    setLoading(true);
    try {
      await uploadTemplate(file, name, Number(typeId), description);
      navigate('/documents/templates');
    } catch (error: any) {
      alert(`Ошибка загрузки: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Преобразуем данные с бэкенда в формат options для JoySelectField
  const documentTypeOptions = types.map(t => ({
    value: String(t.id),
    label: `${t.name} (${t.code})`
  }));

  return (
    <div className="w-full bg-white pb-10">
      <div className="w-full px-4 py-6 sm:px-6 lg:px-8">

        {/* Добавлен mx-auto для центрирования контейнера */}
        <div className="max-w-3xl mx-auto space-y-6">
          <button
            onClick={() => navigate('/documents/templates')}
            className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-900 transition-colors font-medium"
          >
            <BackIcon fontSize="small" /> Назад к списку
          </button>

          <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
            <h2 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
              <UploadIcon className="text-[#1E61AF]" />
              Загрузка нового шаблона
            </h2>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Название шаблона <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all text-sm"
                  placeholder="Например: Договор об оказании платных образовательных услуг"
                />
              </div>

              {/* Используем ваш кастомный селект */}
              <JoySelectField
                label="Тип документа"
                required
                value={typeId}
                onChange={(value) => setTypeId(value || '')}
                options={documentTypeOptions}
                placeholder="Выберите тип документа..."
              />

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Описание (опционально)
                </label>
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  rows={3}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all text-sm resize-none"
                  placeholder="Краткое описание назначения шаблона..."
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Файл шаблона (.docx) <span className="text-red-500">*</span>
                </label>

                {/* Улучшенный и более гармоничный дизайн поля загрузки */}
                <div className="border-2 border-dashed border-gray-300 rounded-xl p-8 flex flex-col items-center justify-center bg-gray-50 hover:bg-blue-50/50 hover:border-blue-300 transition-all duration-200">
                  <UploadIcon className="text-gray-400 mb-4" sx={{ fontSize: 40 }} />

                  <input
                    type="file"
                    accept=".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    required
                    onChange={(e) => setFile(e.target.files?.[0] || null)}
                    className="block w-full max-w-[280px] text-sm text-gray-500
                      file:mr-4 file:py-2 file:px-4
                      file:rounded-md file:border-0
                      file:text-sm file:font-medium
                      file:bg-white file:text-[#1E61AF] file:shadow-sm file:ring-1 file:ring-gray-200
                      hover:file:bg-gray-50 cursor-pointer outline-none mx-auto text-center"
                  />

                  <p className="text-xs text-gray-400 mt-4 text-center">
                    Поддерживается только формат <span className="font-semibold">DOCX</span>
                  </p>
                </div>
              </div>

              <div className="pt-4 flex justify-end border-t border-gray-100">
                <button
                  type="submit"
                  disabled={loading}
                  className={`bg-[#1E61AF] text-white px-6 py-2.5 rounded-lg transition-colors font-medium text-sm flex items-center gap-2 ${loading ? 'opacity-70 cursor-not-allowed' : 'hover:bg-blue-800 shadow-sm'}`}
                >
                  {loading ? 'Загрузка...' : 'Сохранить шаблон'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewTemplate;